import React from 'react';
import '../../styles/SalesFunnel.css';
import awareness from '../../assets/icons/front-end.png';
// import consideration from '../../assets/icons/back-end.png';
import conversion from '../../assets/icons/web-programming.png';
import retention from '../../assets/icons/responsive.png';
import analytics from '../../assets/icons/ecommerce.png';
import testing from '../../assets/icons/cms.png';
import optimization from '../../assets/icons/optimize.png';

const SFservice = () => {
    return (
        <div className="sf-services">
            <h3>Sales Funnel Optimization Services</h3>
            <p className="sf-description">
                We optimize every stage of your sales funnel to increase conversions, improve customer experience, and boost revenue.
            </p>

            <div className="sf-cards-wrapper">
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={awareness} alt="Awareness Stage" /></div>
                    <h3>Awareness Stage Optimization</h3>
                    <p>
                        Attract more qualified traffic with optimized content, SEO, and paid advertising campaigns.
                    </p>
                </div>
                {/* <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={consideration} alt="Consideration Stage" /></div>
                    <h3>Consideration Stage Enhancement</h3>
                    <p>
                        Engage prospects with valuable content and nurturing campaigns that build trust and interest.
                    </p>
                </div> */}
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={conversion} alt="Conversion Optimization" /></div>
                    <h3>Conversion Rate Optimization</h3>
                    <p>
                        Improve landing pages, forms, and checkout processes to increase conversion rates.
                    </p>
                </div>
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={retention} alt="Customer Retention" /></div>
                    <h3>Customer Retention & Loyalty</h3>
                    <p>
                        Keep customers engaged post-purchase with loyalty programs and ongoing engagement strategies.
                    </p>
                </div>
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={analytics} alt="Funnel Analytics" /></div>
                    <h3>Funnel Analytics & Tracking</h3>
                    <p>
                        Comprehensive tracking of funnel metrics to identify bottlenecks and optimization opportunities.
                    </p>
                </div>
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={testing} alt="A/B Testing" /></div>
                    <h3>A/B Testing & Experimentation</h3>
                    <p>
                        Systematic testing of variations to continuously improve conversion rates and funnel performance.
                    </p>
                </div>
                <div className="sf-service-card">
                    <div className="sf-icon"><img className='icon-img' src={optimization} alt="Advanced Optimization" /></div>
                    <h3>Advanced Funnel Optimization</h3>
                    <p>
                        Expert implementation of proven optimization strategies across all funnel stages.
                    </p>
                </div>
                
            </div>
        </div >
    );
};

export default SFservice;







// Key Benefits of Sales Funnel Optimization
// 1. Higher Conversion Rates

// With proper conversion funnel optimization, you can turn more visitors into paying customers.

// 2. Better Customer Experience

// A smooth and engaging funnel improves user experience and builds trust.

// 3. Increased ROI

// Optimized funnels ensure you get maximum returns from your marketing efforts.

// 4. Data-Driven Decisions

// Our sales funnel services use analytics and insights to continuously improve performance.




// Industries We Serve

// Our sales funnel services are suitable for:

// E-commerce businesses
// SaaS companies
// Real estate agencies
// Healthcare providers
// Education platforms
// Digital marketing agencies

// No matter your industry, our sales funnel optimization strategies are designed to deliver results.









// Get Started with High-Converting Lead Generation Funnels

// Ready to scale your business? Our powerful lead generation funnels are designed to attract, engage, and convert your ideal audience.

// With our professional sales funnel services, you can:

// Generate more leads
// Increase conversions
// Grow your revenue